export default __webpack_public_path__ + "static/media/portfolioLinkImg.0d0ed76b.png";